module.exports = __webpack_public_path__ + "images/arrows-up-down-8e8efdd9.svg";